import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "toggleBtn"]

  connect() {
    this.expanded = false
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.previewTarget.classList.add('hidden')
      this.fullTarget.classList.remove('hidden')
      this.toggleBtnTarget.textContent = '← Show less'
    } else {
      this.previewTarget.classList.remove('hidden')
      this.fullTarget.classList.add('hidden')
      this.toggleBtnTarget.textContent = 'Read more →'
    }
  }
}
